import React from 'react';
import { useTranslation } from 'react-i18next';
import { PROFILE_ROUTES } from 'utils/routes';
import PageTitle from 'components/PageTitle';
import UserSkillsWidget from 'screens/UserSkills';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
function StandaloneSkillsProfilePage() {
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(PageTitle, {
      visuallyHidden: true,
      children: t('navbar_my_skills')
    }), /*#__PURE__*/_jsx(UserSkillsWidget, {
      userAnalysisRoutes: {
        root: PROFILE_ROUTES.skills,
        skill: PROFILE_ROUTES.skillsSkill,
        meeting: PROFILE_ROUTES.skillsMeeting
      }
    })]
  });
}
export default StandaloneSkillsProfilePage;